
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { ApiConfiguration, apiReferenceState, loadApiConfiguration } from '../../features/apiReference/apiReferenceSlice';

export const useApiConfiguration = (): [ApiConfiguration | undefined] => {
	const dispatch = useAppDispatch();
	const { apiConfiguration, } = useAppSelector(apiReferenceState);

	useEffect(() => {
		if (!apiConfiguration.isLoading && !apiConfiguration.isSuccess && !apiConfiguration.isError) {
			dispatch(loadApiConfiguration());
		}
	}, [dispatch, apiConfiguration]);

	return [apiConfiguration.config];
}
